export interface CajaQueAcredita {
  activo: boolean;
  deNotas?: boolean;
  usuarioNombre?: string | null;
  comprobantes?: { tipo: string; habilitado: boolean }[];
}

// Una caja que no tiene el tipo 04 habilitado no puede numerar la nota: el backend lo
// rechaza al final, con un mensaje técnico. Mejor no ofrecerla.
export function puedeAcreditar(p: CajaQueAcredita): boolean {
  return (
    p.activo &&
    !!p.usuarioNombre &&
    (p.comprobantes ?? []).some((c) => c.tipo === '04' && c.habilitado)
  );
}

// Con un punto de notas de crédito activo, las notas salen solo por él.
export function cajasQueAcreditan<T extends CajaQueAcredita>(puntos: T[]): T[] {
  const deNotas = puntos.filter((p) => p.activo && p.deNotas);
  return deNotas.length > 0 ? deNotas : puntos.filter(puedeAcreditar);
}
